export default "__VITE_ASSET__1a284d7b__"